<template>
<div>
    <Header></Header>
    <header class="py-3 mb-4 border-bottom">
        <div class="container d-flex flex-wrap justify-content-center">
            <a class="d-flex align-items-center mb-3 mb-lg-0 me-lg-auto text-dark text-decoration-none">
                <button @click="updateFilter('All')" :class="{ 'btn-outline-success': filterStatus === 'All', 'btn btn-outline-success': filterStatus === 'All' }" class="btn mx-2">All</button>
                <button @click="updateFilter('Paid')" :class="{ 'btn-outline-success': filterStatus === 'Paid', 'btn btn-outline-success': filterStatus === 'Paid' }" class="btn mx-2">Paid</button>
                <button @click="updateFilter('Unpaid')" :class="{ 'btn-outline-success': filterStatus === 'Unpaid', 'btn btn-outline-success': filterStatus === 'Unpaid' }" class="btn">Unpaid</button>
                <button @click="updateFilter('OverDue')" :class="{ 'btn-outline-success': filterStatus === 'OverDue', 'btn btn-outline-success': filterStatus === 'OverDue' }" class="btn">OverDue</button>
                <svg class="bi me-2" width="40" height="32">
                    <use xlink:href="#bootstrap" />
                </svg>
                <span class="fs-4"></span>
            </a>

            <form class="col-12 col-lg-auto mb-3 mb-lg-0">
                <input type="search" class="form-control" placeholder="Search..." aria-label="Search" v-model="searchString">
            </form>
        </div>
    </header>
    <div class="container">
        <div v-if="loading" class="d-flex align-items-center justify-content-center gap-3 p-3 font-500">
            <b-spinner></b-spinner> Loading...
        </div>
        <table v-else-if="invoices && invoices.length > 0" class="table table-striped">
            <thead>
                <tr>
                    <th>#</th>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Posting Date</th>
                    <th>Total Amount</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                <tr class="clickable-row" v-for="(invoice,index) in invoices" :key="invoice.name" @click="studentInformation(invoice.name)" v-if="invoice.status !== 'Cancelled'">
                    <td><strong>{{ index + 1 }}</strong></td>
                    <td><strong>{{ invoice.name }}</strong></td>
                    <td>{{ invoice.customer }}</td>
                    <td>{{ formattedDate(invoice.posting_date) }}</td>
                    <td>{{ invoice.total }}</td>
                    <td>{{ invoice.status }}</td>
                </tr>
            </tbody>
        </table>
        <h5 v-else-if="invoices && invoices.length == 0 && !loading" class="text-center text-muted p-4 pt-0 m-0">
            No Invoices found
        </h5>
    </div>
    <Footer></Footer>
</div>
</template>

<script>
import Header from '../components/Layout/Header.vue';
import Footer from './Layout/Footer.vue';
import {
    mapState
} from 'vuex';
export default {
    name: 'InvoiceList',
    data() {
        return {
            invoices: [],
            filterStatus: "All",
            loading: false,
            searchString: null
        };
    },
    components: {
        Header,
        Footer
    },
    computed: {
        ...mapState(["erp_api_url","authorization_token"])
    },
    methods: {
        async fetchInvoicesList() {
            try {
                this.loading = true;
                let apiUrl = this.erp_api_url + 'api/resource/Sales%20Invoice?limit_start=0&limit_page_length=300&fields=["name","owner","creation","modified","customer","company","posting_date","due_date","total","net_total","status","items","docstatus"]&order_by=creation desc';

                if (this.filterStatus != "All") {
                    const filter = `[["Sales Invoice", "status", "=", "${this.filterStatus}"]]`;
                    apiUrl += `&filters=${filter}`;
                }
                const invoicesResponse = await fetch(apiUrl, {
                    method: 'GET',
                    headers: {
                        'Authorization': `${this.authorization_token}`,
                    },
                });
                const invoices = await invoicesResponse.json();
                this.invoices = invoices.data;
            } catch (error) {
                console.error('Error fetching courses:', error);
            } finally {
                this.loading = false;
            }
        },
        updateFilter(status) {
            this.filterStatus = status;
            this.fetchInvoicesList();
        },
        studentInformation(invoiceId) {
            this.$router.push({
                path: '/Student/information',
                query: {
                    invoice: invoiceId,
                }
            });
        },
        formattedDate(dateString) {
            const options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            };
            const formattedDate = new Date(dateString).toLocaleDateString('en-US', options);
            return formattedDate;
        },
    },
    created() {
        this.fetchInvoicesList();
    }
}
</script>

<style scoped>
.clickable-row {
    cursor: pointer;
}
</style>
